export default __webpack_public_path__ + "static/media/home.ad6d5146.svg";